<div class="container">
  <div class="row">
    <div class="col-md-7 pad-bot-40">
      <ng-content></ng-content>
    </div>

    <div class="col-md-1"></div>

    <div class="col-md-4">
      <ng-content select="[layout-last-column]"></ng-content>
    </div>
  </div>
  <div class="pad-bot-9">
    <ng-content select="[page-footer]"></ng-content>
  </div>
</div>
